import React__default, { useState, useRef, useCallback, useEffect } from 'react';
import './BankInfo.scss';

const BankInfo = ({ bankName, accountNumberLastDigits, accountName, bankIconUrl, className, showCheckmarkPlaceholder = false, }) => {
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    const [hasImageError, setHasImageError] = useState(false);
    const timeoutRef = useRef(null);
    const imageRef = useRef(null);
    const handleImageLoad = useCallback(() => {
        // Clear any pending timeout
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setIsImageLoaded(true);
        setHasImageError(false);
    }, []);
    const handleImageError = useCallback(() => {
        // Clear any pending timeout
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setIsImageLoaded(false);
        setHasImageError(true);
    }, []);
    useEffect(() => {
        // Reset states when the bank icon url changes
        setIsImageLoaded(false);
        setHasImageError(false);
        // Clear any existing timeout
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        // If there's a new image URL, set up a timeout fallback
        if (bankIconUrl) {
            // Set a timeout to handle images that never fire load/error events
            timeoutRef.current = setTimeout(() => {
                setIsImageLoaded(false);
                setHasImageError(true);
            }, 10000);
        }
        // Cleanup function
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
    }, [bankIconUrl]);
    return (React__default.createElement("div", { "data-rev-component": 'bank-info', className: className },
        React__default.createElement("div", { className: 'bank-info-image--rev', "data-has-loaded-image": isImageLoaded, "data-has-image-error": hasImageError },
            showCheckmarkPlaceholder ? React__default.createElement(CheckmarkPlaceholderIcon, null) : React__default.createElement(BankPlaceholderIcon, null),
            bankIconUrl && !hasImageError && (React__default.createElement("img", { ref: imageRef, src: bankIconUrl, alt: `${bankName} logo`, className: 'bank-info-image--rev', onLoad: handleImageLoad, onError: handleImageError, loading: 'lazy' }))),
        React__default.createElement("div", { className: 'bank-info-details--rev' },
            React__default.createElement("div", { className: 'bank-info-bank-name--rev' }, bankName),
            accountName ? (React__default.createElement("div", { className: 'bank-info-account-name--rev' }, accountName)) : (React__default.createElement("div", { className: 'bank-info-account-number--rev' }, accountNumberLastDigits)))));
};
const CheckmarkPlaceholderIcon = () => {
    return (React__default.createElement("svg", { className: 'bank-info-checkmark-placeholder-icon--rev placeholder-icon', xmlns: 'http://www.w3.org/2000/svg', width: '40', height: '40', viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '1.2', strokeLinecap: 'round', strokeLinejoin: 'round', "aria-hidden": 'true' },
        React__default.createElement("circle", { cx: '12', cy: '12', r: '10' }),
        React__default.createElement("path", { d: 'm9 12 2 2 4-4' })));
};
const BankPlaceholderIcon = () => (React__default.createElement("div", { className: 'bank-info-bank-placeholder-icon--rev placeholder-icon' },
    React__default.createElement("svg", { width: '401', height: '401', viewBox: '0 0 401 401', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        React__default.createElement("rect", { width: '401', height: '401', fill: '#FAFAFA' }),
        React__default.createElement("rect", { x: '98', y: '169.196', width: '206', height: '131', fill: '#CCCCCC' }),
        React__default.createElement("rect", { x: '139', y: '169.196', width: '42', height: '131', fill: 'white' }),
        React__default.createElement("rect", { x: '221', y: '169.196', width: '42', height: '131', fill: 'white' }),
        React__default.createElement("rect", { x: '67', y: '300.196', width: '268', height: '34', rx: '4', fill: '#CCCCCC' }),
        React__default.createElement("rect", { x: '98', y: '169.196', width: '206', height: '16', fill: '#BCBCBC', fillOpacity: '0.6' }),
        React__default.createElement("rect", { x: '98', y: '284.196', width: '206', height: '16', fill: '#BCBCBC', fillOpacity: '0.6' }),
        React__default.createElement("path", { d: 'M197.562 67.8636C199.739 66.8257 202.269 66.8257 204.446 67.8636L332.931 129.118C334.323 129.781 335.209 131.187 335.209 132.729V165.217C335.209 167.426 333.418 169.217 331.209 169.217H70.7988C68.5897 169.217 66.7988 167.426 66.7988 165.217V132.729C66.7988 131.187 67.6851 129.781 69.0771 129.118L197.562 67.8636ZM201.004 88.0697C194.971 88.0697 190.08 92.9607 190.08 98.9935C190.08 105.026 194.971 109.917 201.004 109.917C207.037 109.917 211.928 105.027 211.928 98.9935C211.928 92.9607 207.037 88.0697 201.004 88.0697Z', fill: '#CCCCCC' }))));

export { BankInfo };
//# sourceMappingURL=BankInfo.js.map
